import React, { useState } from "react";
import { Link } from "react-router-dom";
import AssLoginImg from '../../Images/AssLogin.png'
import "./Login.css";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [animateOut, setAnimateOut] = useState(false);
  const [alertMessage, setAlertMessage] = useState(""); // For popup message

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleLogin = (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setAlertMessage("❌ Invalid email format.");
      return;
    }

    setAnimateOut(true);
    setTimeout(() => {
      onLogin(email);
    }, 600);
  };

  return (
    <div className="login-page">
      {/* Left Panel */}
      <div className="left-panel">
        <img src={AssLoginImg} alt="Login Visual" className="left-pannel-img"/>
      </div>

      {/* Right Panel */}
      <div className={`right-panel ${animateOut ? "fade-out" : ""}`}>
        <div className="form-box">
          <h2 className="login-title">User Login</h2>
          <p className="login-subtitle">Sign in with open account</p>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
                <input
                  type="email"
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label>Enter your email</label>
              </div>

                <button type="submit" className="login-btn">Login</button>
                <div className="admin-link">
                  <Link to="/admin" className="admin">Admin User</Link>
                </div>
              </form>
            </div>
      </div>

      {/* ✅ Custom Alert Popup */}
      {alertMessage && (
        <div className="alert-overlay">
          <div className="alert-box">
            <p>{alertMessage}</p>
            <button className="alert-close" onClick={() => setAlertMessage("")}>×</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;